import { MAXIMUM_HORIZONTAL_ANGLE_OF_VIEW } from 'helpers/globals'

export default function calculateMaxAngleOfView({ aspectRatio }) {
  return MAXIMUM_HORIZONTAL_ANGLE_OF_VIEW / aspectRatio
}



// WEBPACK FOOTER //
// ./src/helpers/calculations/calculateMaxVerticalAngleOfView.js